import React, { useRef, useState, useEffect } from "react";
import { connect } from "react-redux";

import { withRouter } from 'react-router-dom';

import * as TokenActions from '../token/actions';

import Box from '../components/Box';
import Button from '../components/Button';

import '../css/Input.css';

const TransactionStatus = ({ transactions, transactionStack, getTxStatus }) => {
  const [ message, setMessage ] = useState(null);

  useEffect(() => {
    setMessage(getTxStatus());
  }, [transactions, transactionStack]);

  return message ? message : null;
}

const SendPage = ({
  dispatch,
  transactions,
  transactionStack,
  tokenId,
  sent,
  navBarHeight,
  navBarActive,
  handleChangeTo,
  handleChangeTokenId,
  handleSubmit,
  getTxStatus
}) => {
  var inputRef = useRef();
  const [ newTokenId, setNewTokenId ] = useState("");

  useEffect(() => {
    if (sent) {
      setNewTokenId(tokenId);
      dispatch(didFetchTokenId());
    }
  }, [tokenId]);

  const style = navBarActive ? { background: '#F8F8F8' } : { top: navBarHeight, background: '#F8F8F8' };

  return (
    <div>
      <Box className='relative ma4 pv3 ph4' style={style}>
        <div>
          <div className='flex flex-wrap items-center'>
            <h1 className='times-new-roman fw4 mb2 f3 greenmod'>Send tokens</h1>
          </div>
          <div className=''>You can send tokens to another by specifying his address.</div>
          <p className='fw6 mt1 w-100'></p>
        </div>
        <div>
          <form onSubmit={handleSubmit}>
            <label className='Label'></label>
            <input
              ref={ input => { inputRef = input } }
              type="text"
              placeholder="Token ID"
              name="tokenId"
              defaultValue={newTokenId}
              onChange={handleChangeTokenId}
              className='v-mid focus-outline'
              style={{ padding: '1px', borderColor: '#ffffff', width: '30%', maxWidth: '250px' }}
            />
            <label className='Label'></label>
            <input
              type="text"
              placeholder="Address"
              name="to"
              onChange={ e => handleChangeTo(e, inputRef) }
              className='v-mid focus-outline'
              style={{ padding: '1px', borderColor: '#ffffff', width: '50%', maxWidth: '400px' }}
            />
            <Button type="submit" style={{ fontWeight: '400' }}>Send</Button>
            <div className='mv3'></div>
            <TransactionStatus
              transactions={transactions}
              transactionStack={transactionStack}
              getTxStatus={getTxStatus}
              className='db'
            />
          </form>
        </div>
      </Box>
    </div>
  );
}

const didFetchTokenId = () => {
  return {
    type: TokenActions.TOKENID_FETCHED
  }
}

const mapStateToProps = state => ({
  tokenId: state.token.tokenId,
  sent: state.token.sent,
  navBarHeight: state.navigation.navBarHeight,
  navBarActive: state.navigation.navBarActive
});

export default withRouter(connect(mapStateToProps)(SendPage));
